<div class="container-fluid p-0 profile-page">

    <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="showAssistant = true"
    />

    <!-- Moves aside when the assistant panel is docked open -->
    <div class="chatbot-push">
    <div v-if="loading" class="container text-center py-5">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="text-white mt-2">Loading profile...</p>
    </div>

    <div v-else-if="error" class="container py-5">
        <div class="alert alert-danger text-center">
            {{ error }}
        </div>
    </div>

    <section v-else class="container profile-sections py-4">
        <div class="card profile-hero-card p-4 mb-4 overflow-hidden">
            <div class="row g-4 align-items-stretch">
                <div class="col-lg-8 d-flex align-items-center gap-4 flex-column flex-md-row">
                    <div class="profile-avatar d-flex align-items-center justify-content-center flex-shrink-0">
                        <span class="profile-avatar-text text-white">{{ avatar_initials }}</span>
                    </div>

                    <div class="d-flex flex-column gap-3 text-center text-md-start">
                        <span class="badge rounded-pill profile-kicker align-self-center align-self-md-start fw-bold text-uppercase">My account</span>
                        <div>
                            <h2 class="text-white mb-1 profile-hero-name">{{ fullName }}</h2>
                            <p class="text-white-50 mb-0 profile-hero-meta">{{ userRole }} &bull; Member since {{ joinYear }}</p>
                        </div>

                            <div class="d-flex flex-wrap gap-2 justify-content-center justify-content-md-start">
                                <span class="badge rounded-pill profile-meta-pill d-inline-flex align-items-center px-3 py-2 fw-semibold">
                                    <i class="bi bi-person-badge me-2"></i>{{ username }}
                                </span>
                            </div>
                        </div>
                    </div>

                <div class="col-lg-4 d-flex flex-column justify-content-between gap-3">
                    <div>
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <span class="settings-stat-label text-uppercase fw-bold">Profile progress</span>
                            <span class="text-white fw-bold">{{ profileProgress }}%</span>
                        </div>
                        <div
                            class="progress profile-progress rounded-pill"
                            role="progressbar"
                            aria-label="Profile completion"
                            :aria-valuenow="profileProgress"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            <div class="progress-bar bg-primary" :style="{ width: profileProgress + '%' }"></div>
                        </div>
                        <div class="mt-2">
                            <span v-if="remainingItems" class="badge rounded-pill text-bg-danger">
                                {{ remainingItems }} item{{ remainingItems > 1 ? 's' : '' }} remaining
                            </span>
                            <span v-else class="badge rounded-pill text-bg-success">Profile complete</span>
                        </div>
                    </div>

                    <router-link
                        to="/edit_profile"
                        class="btn btn-sm py-2 text-xs btn-primary profile-edit-btn w-100 border-0 text-decoration-none d-inline-flex align-items-center justify-content-center text-white"
                    >
                        <i class="bi bi-pencil-square me-2"></i>
                        <span>Edit Profile</span>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="row g-4">
            <div class="col-12">
                <div class="card profile-surface-card p-4 rounded-4 h-100 overflow-hidden">
                    <div class="d-flex align-items-center gap-3 mb-4">
                        <span class="settings-section-icon d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-4 text-white">
                            <i class="bi bi-address-card-fill"></i>
                        </span>
                        <div>
                            <span class="profile-section-eyebrow fw-bold text-uppercase">Contact</span>
                            <h5 class="text-white fw-bold mb-0 mt-1">Contact Information</h5>
                        </div>
                    </div>

                    <div class="row g-3">
                        <div class="col-md-6">
                            <div class="card profile-info-row p-3 rounded-3 h-100 d-flex align-items-center gap-3">
                            <div class="icon-box d-flex align-items-center justify-content-center flex-shrink-0">
                                <i class="bi bi-envelope-fill text-white"></i>
                            </div>
                            <div class="d-flex flex-column">
                                <span class="settings-stat-label text-uppercase fw-bold">Email</span>
                                <span class="text-white fw-semibold">{{ userEmail }}</span>
                            </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="card profile-info-row p-3 rounded-3 h-100 d-flex align-items-center gap-3">
                            <div class="icon-box d-flex align-items-center justify-content-center flex-shrink-0">
                                <i class="bi bi-telephone-fill text-white"></i>
                            </div>
                            <div class="d-flex flex-column">
                                <span class="settings-stat-label text-uppercase fw-bold">Phone</span>
                                <span class="text-white fw-semibold">{{ userPhone }}</span>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card profile-surface-card p-4 rounded-4 mt-4 overflow-hidden">
            <div class="d-flex align-items-center gap-3 mb-4">
                <span class="settings-section-icon d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-4 text-white">
                    <i class="bi bi-list-check"></i>
                </span>
                <div>
                    <span class="profile-section-eyebrow fw-bold text-uppercase">Checklist</span>
                    <h5 class="text-white fw-bold mb-0 mt-1">Complete Your Profile</h5>
                </div>
            </div>

            <div class="row g-3">
                <div class="col-md-6">
                    <div class="card completion-item p-3 rounded-3 d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-envelope-fill me-2 text-white-50"></i>
                            <span class="text-white-50">Email</span>
                        </div>
                        <span class="badge rounded-pill text-bg-success">Verified</span>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="card completion-item p-3 rounded-3 d-flex align-items-center justify-content-between" :class="{ 'incomplete': !hasPhoneNumber }">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-telephone-fill me-2 text-white-50"></i>
                            <span class="text-white-50">Phone Number</span>
                        </div>
                        <span class="badge rounded-pill" :class="hasPhoneNumber ? 'text-bg-success' : 'text-bg-danger'">
                            {{ hasPhoneNumber ? 'Added' : 'Missing' }}
                        </span>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="card completion-item p-3 rounded-3 d-flex align-items-center justify-content-between" :class="{ 'incomplete': !userProfile?.first_name }">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-person-fill me-2 text-white-50"></i>
                            <span class="text-white-50">First Name</span>
                        </div>
                        <span class="badge rounded-pill" :class="userProfile?.first_name ? 'text-bg-success' : 'text-bg-danger'">
                            {{ userProfile?.first_name ? 'Added' : 'Missing' }}
                        </span>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="card completion-item p-3 rounded-3 d-flex align-items-center justify-content-between" :class="{ 'incomplete': !userProfile?.last_name }">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-person-fill me-2 text-white-50"></i>
                            <span class="text-white-50">Last Name</span>
                        </div>
                        <span class="badge rounded-pill" :class="userProfile?.last_name ? 'text-bg-success' : 'text-bg-danger'">
                            {{ userProfile?.last_name ? 'Added' : 'Missing' }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>

    <BolideAssistant :is_open="showAssistant" @close-assistant="showAssistant = false" />

</div>
